import { map } from "underscore";

const getters = {
  isLoadingComplete: state => {
    const { total, eforms } = state;

    return total === eforms.length ? true : false;
  },
  getFolders: state => {
    const { folders } = state;

    return map(folders, (folder: any) => {
      const { carpeta_id, carpeta_nombre, tipo_id, tipo_nombre } = folder;

      return { carpeta_id, carpeta_nombre, tipo_id, tipo_nombre };
    });
  },
  eformSelected: ({ eform }) => {
    return {
      nombre: eform.nombre || eform.titulo,
      estadoText: eform.estadoText,
      id: eform.id,
      pickup: eform.pickup,
      certificate: eform.certificate,
      required_approval: eform.required_approval || false,
      idCarpeta: eform.idCarpeta || '',
      idpickupform: eform.idpickupform || '',
    };
  }
};

export default getters;
